<template>
  <div>
    <!-- Table dialog servicios -->
    <el-dialog
      :title="title"
      :visible="isVisible"
      :before-close="handleClose"
      :fullscreen="false"
      top="5vh"
      width="80%"
      center
    >
      <el-row>
        <el-col :span="20" :offset="2">
          <el-card class="box-card">
            <el-table
              :data="history"
              style="width: 100%"
              :default-sort="{ prop: 'date', order: 'descending' }"
              stripe
            >
              <el-table-column
                label="Autor"
                prop="author"
                align="center"
                sortable
              >
                <template slot-scope="props">
                  <h4>
                    <i class="el-icon-user"></i>
                    {{ props.row.author }}
                  </h4>
                </template>
              </el-table-column>

              <el-table-column
                label="Ubicación"
                prop="address"
                align="center"
                sortable
              >
                <template slot-scope="props">
                  <h4>
                    <i class="el-icon-user"></i>
                    {{ props.row.address.country }} -
                    {{ props.row.address.state }} -
                    {{ props.row.address.city }} -
                    {{ props.row.address.postalCode }} -
                    {{ props.row.address.sector }}
                  </h4>
                </template>
              </el-table-column>

              <el-table-column
                label="Deshabilitado"
                prop="disabled"
                align="center"
                sortable
              >
                <template slot-scope="props">
                  <h4>
                    <i class="el-icon-user"></i>
                    {{ props.row.disabled || "Ningúno" }}
                  </h4>
                </template>
              </el-table-column>

              <el-table-column label="Cambios" align="center">
                <template slot-scope="props">
                  <div v-if="verifyType(props.row.changes)">
                    <h4 class="change-item">{{ props.row.changes }}</h4>
                  </div>
                  <div
                    v-else
                    v-for="(value, key) in props.row.changes"
                    :key="key"
                  >
                    <h4 class="change-item" v-if="key !== 'disabled'">
                      {{
                        {
                          isOcurre: "Ocurre",
                          days: "Días",
                          outOfArea: "Fuera del área",
                          outOfPickup: "Fuera de Pickup",
                          covered: "Cobertura",
                        }[key]
                      }}: {{ value }}
                    </h4>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="Fecha"
                align="center"
                prop="date"
                sortable
              >
                <template slot-scope="props">
                  <i class="el-icon-time"></i>
                  {{ props.row.date | formatDate }}
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- END Table dialog services -->
  </div>
</template>

<script>
import { CSApi } from "@/libraries/api";

export default {
  name: "DialogHistoryCoverage",
  components: {},
  props: ["address", "service", "isVisible", "disabled"],
  data() {
    return {
      title: "",
      history: [],
    };
  },
  watch: {
    async isVisible() {
      this.title = "Historial de Cobertura";

      const response = await CSApi().get(
        `coverage/history?page=1&pageSize=500&address=${this.address}&service=${
          this.service
        }&searchBy=${this.disabled || "null"}`
      );
      const { data } = response.data;
      this.history = data;
    },
  },

  methods: {
    verifyType(val) {
      return typeof val == "string";
    },
    handleClose() {
      this.$emit("close");
    },

    update() {
      this.$emit("update");
    },
  },
};
</script>

<style>
.el-select-dropdown__item {
  padding: 10px 20px;
  height: 55px;
  width: 330px;
}
.el-form-item__label {
  font-size: 14px;
  font-weight: 100;
  line-height: 14px;
}
.el-switch__label * {
  line-height: 1;
  font-size: 14px;
  font-weight: 100;
}
.el-input .el-input--small .el-input--suffix {
  width: 260px;
}
</style>
